import { Navigate, Outlet } from 'react-router-dom';

export default function GuestGuard() {
    const isAuthenticated = !!localStorage.getItem('wp_jwt');
    return !isAuthenticated ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
